import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../../../theme';
import LibrarySearchControls from './library-search-controls';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
    },
    listActionBar: {
      paddingRight: theme.spacing(0),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(0),
      paddingTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      borderBottom: `solid 1px ${theme.palette.primary.main}`,
    },
  }),
);

export default function LibraryActionBar(props: any) {
  const classes = useStyles(baseTheme);

  return (
    <Grid item container className={classes.listActionBar}>
      <LibrarySearchControls />
    </Grid>
  );
}
